<template>
  <!-- ── Breadcrumb ─────────────────────────────────────────────── -->
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-2">
      <p>
        <span class="breadcrumb-item" @click="irInicio">Inicio</span>
        &gt;
        <span v-if="tabActiva==='canales' && vista === 'formulario'" class="breadcrumb-item" @click="volver">Personalización Tipster</span>
        <span v-else-if="tabActiva==='servicios' && vistaSrv === 'formulario'" class="breadcrumb-item" @click="volverSrv">Personalización Tipster</span>
        <span v-else>Personalización Tipster</span>
        <template v-if="tabActiva==='canales' && vista === 'formulario'">
          &gt; {{ editandoTipsterNombre }} › {{ form.nombre || 'Nueva' }}
        </template>
        <template v-if="tabActiva==='servicios' && vistaSrv === 'formulario'">
          &gt; {{ editandoSrvTipsterNombre }} › {{ formSrv.nombre || 'Nueva' }}
        </template>
      </p>
    </div>
    <!-- Tabs -->
    <div class="pers-tabs mb-4">
      <button :class="['pers-tab', tabActiva==='canales' && 'pers-tab--activo']" @click="cambiarTab('canales')">📢 Canales</button>
      <button :class="['pers-tab', tabActiva==='servicios' && 'pers-tab--activo']" @click="cambiarTab('servicios')">🛒 Servicios</button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════
       VISTA: LISTA DE TIPSTERS Y SUS PERSONALIZACIONES
  ═══════════════════════════════════════════════════════════════ -->
  <!-- ══ TAB CANALES ══ -->
  <template v-if="tabActiva === 'canales'">
  <div v-if="vista === 'lista'" class="px-4 container-fluid">
    <div v-if="cargando" class="pers-empty text-center py-5">
      <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
      <p>Cargando personalizaciones...</p>
    </div>

    <div v-else-if="tipsters.length === 0" class="pers-empty text-center py-5">
      <i class="fa fa-paint-brush fa-2x mb-3"></i>
      <p>No hay tipsters asignados.</p>
    </div>

    <template v-else>
      <div v-for="t in tipsters" :key="t.tipster_id" class="tipster-group mb-4">
        <!-- Cabecera del tipster -->
        <div class="tipster-group-header">
          <span class="tipster-group-nombre">{{ t.tipster_nombre }}</span>
          <button class="btn-nuevo-pers" @click="abrirFormulario(t.tipster_id, t.tipster_nombre, null)">
            <i class="fa fa-plus"></i> Nueva
          </button>
        </div>

        <!-- Sin personalizaciones -->
        <div v-if="t.personalizaciones.length === 0" class="pers-list-empty">
          Sin personalizaciones — crea una con el botón «Nueva»
        </div>

        <!-- Lista de personalizaciones -->
        <div v-else class="pers-list">
          <div v-for="p in t.personalizaciones" :key="p.id" class="pers-list-item">
            <div class="pers-list-item-info">
              <span class="pers-list-nombre">{{ p.nombre }}</span>
              <div class="pers-list-chips">
                <span v-if="p.imagen_landing || p.imagen_fondo || p.imagen_banner" class="pers-chip"><i class="fa fa-image"></i> imgs</span>
                <span v-if="p.subtitulo" class="pers-chip"><i class="fa fa-font"></i> texto</span>
                <span v-if="p.color_primario" class="pers-color-dot" :style="{ background: p.color_primario }" :title="p.color_primario"></span>
                <span v-if="p.color_secundario" class="pers-color-dot" :style="{ background: p.color_secundario }" :title="p.color_secundario"></span>
              </div>
            </div>
            <div class="pers-list-item-actions">
              <button class="btn-pers-secondary btn-sm" @click="abrirFormulario(t.tipster_id, t.tipster_nombre, p)">
                <i class="fa fa-edit"></i> Editar
              </button>
              <button class="btn-pers-danger btn-sm" @click="confirmarBorrar(t.tipster_id, p.id, p.nombre)" :disabled="borrando === p.id">
                <i class="fa fa-spinner fa-spin" v-if="borrando === p.id"></i>
                <i class="fa fa-trash" v-else></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div v-if="mensajeError" class="pers-toast pers-toast--err mt-3">
      <i class="fa fa-exclamation-circle"></i> {{ mensajeError }}
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════
       VISTA: FORMULARIO DE EDICIÓN / CREACIÓN
  ═══════════════════════════════════════════════════════════════ -->
  <div v-else class="px-4 container-fluid">
    <div class="row">
      <!-- Panel izquierdo: formulario -->
      <div class="col-12 col-lg-6">
        <div class="card pers-card">
          <div class="pers-card-header">
            <div class="form-header-row">
              <button class="btn-volver" @click="volver">
                <i class="fa fa-arrow-left"></i> Volver
              </button>
              <div>
                <h5 class="pers-title">{{ editandoId ? 'Editar personalización' : 'Nueva personalización' }}</h5>
                <p class="pers-subtitle">{{ editandoTipsterNombre }}</p>
              </div>
            </div>
          </div>

          <!-- Nombre + Idioma -->
          <div class="nombre-idioma-row">
            <div class="pers-field mb-0 flex-1">
              <label class="pers-label">Nombre <span class="pers-hint">· Identifica esta personalización</span></label>
              <input v-model="form.nombre" type="text" class="pers-input" placeholder="Ej: Principal, Versión inglés..." maxlength="100" />
            </div>
            <div class="pers-field mb-0 idioma-select-wrap">
              <label class="pers-label">Idioma</label>
              <select v-model="form.idioma" class="pers-input">
                <option v-for="l in IDIOMAS" :key="l.code" :value="l.code">{{ l.label }}</option>
              </select>
            </div>
          </div>

          <div class="pers-field">
            <label class="pers-label">Nombre a mostrar en landings <span class="pers-hint">· Si está vacío usa el nombre real del tipster</span></label>
            <input v-model="form.nombre_mostrar" type="text" class="pers-input" placeholder="Ej: GreenTipster, TipsterVerde EN..." maxlength="100" />
          </div>

          <!-- SECCIÓN: Imágenes -->
          <div class="pers-section-title">Imágenes</div>

          <!-- Imagen de fondo -->
          <div class="pers-field">
            <label class="pers-label">Imagen de fondo <span class="pers-hint">· Se muestra detrás de todo el contenido</span></label>
            <div class="imagen-upload-area" @click="$refs.inputFondo.click()" @dragover.prevent @drop.prevent="e => onDropGenerico(e, 'fondo')">
              <img v-if="fondoPreviewUrl" :src="fondoPreviewUrl" class="imagen-preview imagen-preview--fondo" alt="Fondo" />
              <div v-else class="imagen-placeholder">
                <i class="fa fa-image fa-2x mb-2"></i>
                <span>Imagen de fondo</span>
                <span class="imagen-hint">JPG, PNG, WEBP · máx. 5MB · recomendado 1080×1920</span>
              </div>
            </div>
            <input ref="inputFondo" type="file" accept="image/jpeg,image/png,image/webp" class="d-none" @change="e => onSeleccionarGenerico(e, 'fondo')" />
            <div class="img-btn-row mt-2">
              <button v-if="localFiles.fondo" class="btn-pers-secondary" @click="subirImagenGenerico('fondo')" :disabled="subiendo.fondo">
                <span v-if="subiendo.fondo"><i class="fa fa-spinner fa-spin"></i> Subiendo...</span>
                <span v-else><i class="fa fa-upload"></i> Subir</span>
              </button>
              <button v-if="form.imagen_fondo" class="btn-pers-danger" @click="quitarImagenGenerico('fondo')">
                <i class="fa fa-trash"></i> Quitar
              </button>
            </div>
          </div>

          <!-- Banner -->
          <div class="pers-field">
            <label class="pers-label">Banner <span class="pers-hint">· Imagen ancha en la parte superior</span></label>
            <div class="imagen-upload-area imagen-upload-area--banner" @click="$refs.inputBanner.click()" @dragover.prevent @drop.prevent="e => onDropGenerico(e, 'banner')">
              <img v-if="bannerPreviewUrl" :src="bannerPreviewUrl" class="imagen-preview" alt="Banner" />
              <div v-else class="imagen-placeholder">
                <i class="fa fa-picture-o fa-2x mb-2"></i>
                <span>Banner superior</span>
                <span class="imagen-hint">JPG, PNG, WEBP · máx. 5MB · recomendado 1080×400</span>
              </div>
            </div>
            <input ref="inputBanner" type="file" accept="image/jpeg,image/png,image/webp" class="d-none" @change="e => onSeleccionarGenerico(e, 'banner')" />
            <div class="img-btn-row mt-2">
              <button v-if="localFiles.banner" class="btn-pers-secondary" @click="subirImagenGenerico('banner')" :disabled="subiendo.banner">
                <span v-if="subiendo.banner"><i class="fa fa-spinner fa-spin"></i> Subiendo...</span>
                <span v-else><i class="fa fa-upload"></i> Subir</span>
              </button>
              <button v-if="form.imagen_banner" class="btn-pers-danger" @click="quitarImagenGenerico('banner')">
                <i class="fa fa-trash"></i> Quitar
              </button>
            </div>
          </div>

          <!-- Foto/avatar tipster -->
          <div class="pers-field">
            <label class="pers-label">Foto del tipster <span class="pers-hint">· Avatar circular en el centro</span></label>
            <div class="imagen-upload-area" @click="$refs.inputImagen.click()" @dragover.prevent @drop.prevent="e => onDropGenerico(e, 'landing')">
              <img v-if="landingPreviewUrl" :src="landingPreviewUrl" class="imagen-preview imagen-preview--avatar" alt="Avatar" />
              <div v-else class="imagen-placeholder">
                <i class="fa fa-user-circle fa-2x mb-2"></i>
                <span>Foto o logo del tipster</span>
                <span class="imagen-hint">JPG, PNG, WEBP · máx. 5MB · cuadrada recomendado</span>
              </div>
            </div>
            <input ref="inputImagen" type="file" accept="image/jpeg,image/png,image/webp" class="d-none" @change="e => onSeleccionarGenerico(e, 'landing')" />
            <div class="img-btn-row mt-2">
              <button v-if="localFiles.landing" class="btn-pers-secondary" @click="subirImagenGenerico('landing')" :disabled="subiendo.landing">
                <span v-if="subiendo.landing"><i class="fa fa-spinner fa-spin"></i> Subiendo...</span>
                <span v-else><i class="fa fa-upload"></i> Subir</span>
              </button>
              <button v-if="form.imagen_landing" class="btn-pers-danger" @click="quitarImagenGenerico('landing')">
                <i class="fa fa-trash"></i> Quitar
              </button>
            </div>
          </div>

          <!-- SECCIÓN: Colores -->
          <div class="pers-section-title">Paleta de colores</div>
          <div class="pers-field">
            <div class="colores-row">
              <div class="color-picker-group">
                <label class="pers-label-sm">Color de fondo</label>
                <p class="pers-color-desc">Base oscura de la landing (fondos, cards)</p>
                <div class="color-pick-wrap">
                  <input type="color" v-model="form.color_primario" class="color-input" />
                  <input v-model="form.color_primario" type="text" class="pers-input color-hex" placeholder="#1a2b3c" maxlength="7" @input="normalizarHex('color_primario')" />
                </div>
              </div>
              <div class="color-picker-group">
                <label class="pers-label-sm">Color de acento</label>
                <p class="pers-color-desc">Botones, textos destacados y CTA</p>
                <div class="color-pick-wrap">
                  <input type="color" v-model="form.color_secundario" class="color-input" />
                  <input v-model="form.color_secundario" type="text" class="pers-input color-hex" placeholder="#f5a623" maxlength="7" @input="normalizarHex('color_secundario')" />
                </div>
              </div>
              <div class="color-picker-group">
                <label class="pers-label-sm">Color del texto</label>
                <p class="pers-color-desc">Color base de los textos de la landing</p>
                <div class="color-pick-wrap">
                  <input type="color" v-model="form.color_texto" class="color-input" />
                  <input v-model="form.color_texto" type="text" class="pers-input color-hex" placeholder="#ffffff" maxlength="7" @input="normalizarHex('color_texto')" />
                </div>
              </div>
            </div>
          </div>

          <!-- SECCIÓN: Textos -->
          <div class="pers-section-title">Textos</div>

          <!-- Suscriptores -->
          <div class="pers-field">
            <label class="pers-label">Suscriptores <span class="pers-hint">(cifra manual, actualizable)</span></label>
            <input v-model.number="form.suscriptores" type="number" min="0" class="pers-input" placeholder="Ej: 12500" />
          </div>

          <!-- Subtítulo -->
          <div class="pers-field emoji-field" v-click-outside="() => cerrarEmoji('subtitulo')">
            <div class="label-emoji-row">
              <label class="pers-label">Subtítulo <span class="pers-hint">(máx. 255 caracteres)</span></label>
              <button type="button" class="btn-emoji-toggle" @click.stop="toggleEmoji('subtitulo')" title="Insertar emoji">😊</button>
            </div>
            <div v-if="emojiPanelAbierto === 'subtitulo'" class="emoji-panel">
              <div v-for="(lista, cat) in EMOJIS" :key="cat" class="emoji-cat">
                <div class="emoji-cat-label">{{ cat }}</div>
                <div class="emoji-grid">
                  <span v-for="e in lista" :key="e" class="emoji-item" @click="insertarEmoji('subtitulo', e)">{{ e }}</span>
                </div>
              </div>
            </div>
            <input ref="inputSubtitulo" v-model="form.subtitulo" type="text" class="pers-input" placeholder="El mejor tipster de fútbol de habla hispana" maxlength="255" @blur="guardarCursor('subtitulo')" />
            <span class="char-count">{{ (form.subtitulo || '').length }}/255</span>
          </div>

          <!-- Mensaje promocional -->
          <div class="pers-field emoji-field" v-click-outside="() => cerrarEmoji('mensaje_promocional')">
            <div class="label-emoji-row">
              <label class="pers-label">Mensaje promocional <span class="pers-hint">(entre subtítulo y el botón)</span></label>
              <button type="button" class="btn-emoji-toggle" @click.stop="toggleEmoji('mensaje_promocional')" title="Insertar emoji">😊</button>
            </div>
            <div v-if="emojiPanelAbierto === 'mensaje_promocional'" class="emoji-panel">
              <div v-for="(lista, cat) in EMOJIS" :key="cat" class="emoji-cat">
                <div class="emoji-cat-label">{{ cat }}</div>
                <div class="emoji-grid">
                  <span v-for="e in lista" :key="e" class="emoji-item" @click="insertarEmoji('mensaje_promocional', e)">{{ e }}</span>
                </div>
              </div>
            </div>
            <textarea ref="inputMensaje_promocional" v-model="form.mensaje_promocional" class="pers-textarea" rows="3" placeholder="✅ +95% aciertos en la temporada&#10;🏆 El canal más seguido de España" maxlength="500" @blur="guardarCursor('mensaje_promocional')"></textarea>
            <span class="char-count">{{ (form.mensaje_promocional || '').length }}/500</span>
          </div>

          <!-- SECCIÓN: Tracking -->
          <div class="pers-section-title">Tracking publicitario</div>

          <div class="pers-field">
            <label class="pers-label">Meta Pixel ID <span class="pers-hint">· ID del dataset de esta campaña</span></label>
            <input v-model="form.meta_pixel_id" type="text" class="pers-input" placeholder="Ej: 949005258220518" maxlength="50" />
            <span class="pers-field-help">El Pixel ID se obtiene desde Meta Events Manager. Solo se activa si está rellenado.</span>
          </div>

          <div class="row g-3">
            <div class="col-12 col-md-6">
              <div class="pers-field mb-0">
                <label class="pers-label">Meta Page ID — Español <span class="pers-hint">· ESP, MEX, ARG…</span></label>
                <input v-model="form.meta_page_id_es" type="text" class="pers-input" placeholder="Ej: 123456789012345" maxlength="30" />
                <span class="pers-field-help">Fan page en español. Necesario para crear anuncios en Meta.</span>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="pers-field mb-0">
                <label class="pers-label">Meta Page ID — Inglés <span class="pers-hint">· USA, GBR, AUS…</span></label>
                <input v-model="form.meta_page_id_en" type="text" class="pers-input" placeholder="Ej: 987654321098765" maxlength="30" />
                <span class="pers-field-help">Fan page en inglés. Se usa en mercados angloparlantes.</span>
              </div>
            </div>
          </div>

          <!-- Acciones -->
          <div class="pers-actions">
            <button class="btn-pers-primary" @click="guardar" :disabled="guardando || hayArchivosLocales || !form.nombre">
              <span v-if="guardando"><i class="fa fa-spinner fa-spin"></i> Guardando...</span>
              <span v-else-if="hayArchivosLocales"><i class="fa fa-exclamation-triangle"></i> Sube las imágenes primero</span>
              <span v-else-if="!form.nombre"><i class="fa fa-exclamation-triangle"></i> Introduce un nombre</span>
              <span v-else><i class="fa fa-save"></i> Guardar cambios</span>
            </button>
          </div>

          <div v-if="mensajeOk" class="pers-toast pers-toast--ok"><i class="fa fa-check-circle"></i> {{ mensajeOk }}</div>
          <div v-if="mensajeError" class="pers-toast pers-toast--err"><i class="fa fa-exclamation-circle"></i> {{ mensajeError }}</div>
        </div>
      </div>

      <!-- Panel derecho: preview -->
      <div class="col-12 col-lg-6 mt-4 mt-lg-0">
        <div class="card pers-card">
          <div class="pers-card-header">
            <h5 class="pers-title">Vista previa</h5>
            <p class="pers-subtitle">Así verán la landing tus suscriptores</p>
          </div>
          <div class="preview-phone-wrap">
            <div class="preview-phone">
              <div class="preview-landing" :style="landingStyle">
                <div v-if="bannerPreviewUrl" class="prev-banner-wrap">
                  <img :src="bannerPreviewUrl" class="prev-banner" alt="Banner" />
                </div>
                <div v-else class="prev-banner-placeholder" :style="{ background: form.color_primario || '#0e141f' }"></div>

                <div class="prev-img-wrap">
                  <img v-if="landingPreviewUrl" :src="landingPreviewUrl" class="prev-img" alt="Tipster" />
                  <div v-else class="prev-img prev-img--placeholder"><i class="fa fa-user fa-2x"></i></div>
                </div>

                <div class="prev-tipster-nombre">{{ form.nombre_mostrar || editandoTipsterNombre }}</div>

                <div v-if="form.suscriptores" class="prev-suscriptores" :style="{ color: form.color_secundario || '#f5a623' }">
                  <i class="fa fa-users"></i> {{ formatNum(form.suscriptores) }} {{ textosLanding.suscriptores }}
                </div>

                <div v-if="form.subtitulo" class="prev-subtitulo">{{ form.subtitulo }}</div>
                <div v-if="form.mensaje_promocional" class="prev-mensaje">{{ form.mensaje_promocional }}</div>

                <div class="prev-free" :style="{ color: form.color_secundario || '#f5a623' }">{{ textosLanding.libre }}</div>
                <button class="prev-btn-unete" :style="btnUneteStyle">{{ textosLanding.boton }}</button>
              </div>
            </div>
          </div>

          <div class="palette-preview" v-if="form.color_primario || form.color_secundario">
            <span class="palette-label">Paleta:</span>
            <div class="palette-chip" :style="{ background: form.color_primario }" :title="form.color_primario"></div>
            <div class="palette-chip" :style="{ background: form.color_secundario }" :title="form.color_secundario"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
  <!-- ══ FIN TAB CANALES ══ -->

  <!-- ══ TAB SERVICIOS ══ -->
  <template v-if="tabActiva === 'servicios'">

  <!-- VISTA: LISTA SERVICIOS -->
  <div v-if="vistaSrv === 'lista'" class="px-4 container-fluid">
    <div v-if="cargandoSrv" class="pers-empty text-center py-5">
      <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
      <p>Cargando personalizaciones de servicios...</p>
    </div>
    <div v-else-if="tipstersSrv.length === 0" class="pers-empty text-center py-5">
      <p>No hay tipsters asignados.</p>
    </div>
    <template v-else>
      <div v-for="t in tipstersSrv" :key="t.tipster_id" class="tipster-group mb-4">
        <div class="tipster-group-header">
          <span class="tipster-group-nombre">{{ t.tipster_nombre }}</span>
          <button class="btn-nuevo-pers" @click="abrirFormularioSrv(t.tipster_id, t.tipster_nombre, null)">
            <i class="fa fa-plus"></i> Nueva
          </button>
        </div>
        <div v-if="t.personalizaciones.length === 0" class="pers-list-empty">
          Sin personalizaciones — crea una con el botón «Nueva»
        </div>
        <div v-else class="pers-list">
          <div v-for="p in t.personalizaciones" :key="p.id" class="pers-list-item">
            <div class="pers-list-item-info">
              <span class="pers-list-nombre">{{ p.nombre }}</span>
              <div class="pers-list-chips">
                <span v-if="p.imagen_landing || p.imagen_fondo || p.imagen_banner" class="pers-chip"><i class="fa fa-image"></i> imgs</span>
                <span v-if="p.subtitulo" class="pers-chip"><i class="fa fa-font"></i> texto</span>
                <span v-if="p.color_primario" class="pers-color-dot" :style="{ background: p.color_primario }"></span>
                <span v-if="p.color_secundario" class="pers-color-dot" :style="{ background: p.color_secundario }"></span>
              </div>
            </div>
            <div class="pers-list-item-actions">
              <button class="btn-pers-secondary btn-sm" @click="abrirFormularioSrv(t.tipster_id, t.tipster_nombre, p)">
                <i class="fa fa-edit"></i> Editar
              </button>
              <button class="btn-pers-danger btn-sm" @click="confirmarBorrarSrv(t.tipster_id, p.id, p.nombre)" :disabled="borrandoSrv === p.id">
                <i class="fa fa-spinner fa-spin" v-if="borrandoSrv === p.id"></i>
                <i class="fa fa-trash" v-else></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="mensajeErrorSrv" class="pers-toast pers-toast--err mt-3">
      <i class="fa fa-exclamation-circle"></i> {{ mensajeErrorSrv }}
    </div>
  </div>

  <!-- VISTA: FORMULARIO SERVICIOS -->
  <div v-else class="px-4 container-fluid">
    <div class="row">
      <!-- Panel izquierdo: formulario -->
      <div class="col-12 col-lg-6">
        <div class="card pers-card">
          <div class="pers-card-header">
            <div class="form-header-row">
              <button class="btn-volver" @click="volverSrv">
                <i class="fa fa-arrow-left"></i> Volver
              </button>
              <div>
                <h5 class="pers-title">{{ editandoSrvId ? 'Editar personalización' : 'Nueva personalización' }}</h5>
                <p class="pers-subtitle">{{ editandoSrvTipsterNombre }}</p>
              </div>
            </div>
          </div>

          <!-- Nombre + Idioma -->
          <div class="nombre-idioma-row">
            <div class="pers-field mb-0 flex-1">
              <label class="pers-label">Nombre <span class="pers-hint">· Identifica esta personalización</span></label>
              <input v-model="formSrv.nombre" type="text" class="pers-input" placeholder="Ej: ES Grupo ORO servicio" maxlength="100" />
            </div>
            <div class="pers-field mb-0 idioma-select-wrap">
              <label class="pers-label">Idioma</label>
              <select v-model="formSrv.idioma" class="pers-input">
                <option v-for="l in IDIOMAS" :key="l.code" :value="l.code">{{ l.label }}</option>
              </select>
            </div>
          </div>

          <div class="pers-field">
            <label class="pers-label">Nombre a mostrar en landings <span class="pers-hint">· Si está vacío usa el nombre real del tipster</span></label>
            <input v-model="formSrv.nombre_mostrar" type="text" class="pers-input" placeholder="Ej: GreenTipster, TipsterVerde EN..." maxlength="100" />
          </div>

          <!-- SECCIÓN: Imágenes -->
          <div class="pers-section-title">Imágenes</div>

          <!-- Imagen de fondo -->
          <div class="pers-field">
            <label class="pers-label">Imagen de fondo <span class="pers-hint">· Se muestra detrás de todo el contenido</span></label>
            <div class="imagen-upload-area" @click="$refs.inputSrvFondo.click()" @dragover.prevent @drop.prevent="e => onDropSrv(e, 'fondo')">
              <img v-if="fondoPreviewUrlSrv" :src="fondoPreviewUrlSrv" class="imagen-preview imagen-preview--fondo" alt="Fondo" />
              <div v-else class="imagen-placeholder">
                <i class="fa fa-image fa-2x mb-2"></i>
                <span>Imagen de fondo</span>
                <span class="imagen-hint">JPG, PNG, WEBP · máx. 5MB · recomendado 1080×1920</span>
              </div>
            </div>
            <input ref="inputSrvFondo" type="file" accept="image/jpeg,image/png,image/webp" class="d-none" @change="e => onSeleccionarSrv(e, 'fondo')" />
            <div class="img-btn-row mt-2">
              <button v-if="localFilesSrv.fondo" class="btn-pers-secondary" @click="subirImagenSrv('fondo')" :disabled="subiendoSrv.fondo">
                <span v-if="subiendoSrv.fondo"><i class="fa fa-spinner fa-spin"></i> Subiendo...</span>
                <span v-else><i class="fa fa-upload"></i> Subir</span>
              </button>
              <button v-if="formSrv.imagen_fondo" class="btn-pers-danger" @click="quitarImgSrv('fondo')">
                <i class="fa fa-trash"></i> Quitar
              </button>
            </div>
          </div>

          <!-- Banner -->
          <div class="pers-field">
            <label class="pers-label">Banner <span class="pers-hint">· Imagen ancha en la parte superior</span></label>
            <div class="imagen-upload-area imagen-upload-area--banner" @click="$refs.inputSrvBanner.click()" @dragover.prevent @drop.prevent="e => onDropSrv(e, 'banner')">
              <img v-if="bannerPreviewUrlSrv" :src="bannerPreviewUrlSrv" class="imagen-preview" alt="Banner" />
              <div v-else class="imagen-placeholder">
                <i class="fa fa-picture-o fa-2x mb-2"></i>
                <span>Banner superior</span>
                <span class="imagen-hint">JPG, PNG, WEBP · máx. 5MB · recomendado 1080×400</span>
              </div>
            </div>
            <input ref="inputSrvBanner" type="file" accept="image/jpeg,image/png,image/webp" class="d-none" @change="e => onSeleccionarSrv(e, 'banner')" />
            <div class="img-btn-row mt-2">
              <button v-if="localFilesSrv.banner" class="btn-pers-secondary" @click="subirImagenSrv('banner')" :disabled="subiendoSrv.banner">
                <span v-if="subiendoSrv.banner"><i class="fa fa-spinner fa-spin"></i> Subiendo...</span>
                <span v-else><i class="fa fa-upload"></i> Subir</span>
              </button>
              <button v-if="formSrv.imagen_banner" class="btn-pers-danger" @click="quitarImgSrv('banner')">
                <i class="fa fa-trash"></i> Quitar
              </button>
            </div>
          </div>

          <!-- Foto/avatar tipster -->
          <div class="pers-field">
            <label class="pers-label">Foto del tipster <span class="pers-hint">· Avatar circular en el centro</span></label>
            <div class="imagen-upload-area" @click="$refs.inputSrvLanding.click()" @dragover.prevent @drop.prevent="e => onDropSrv(e, 'landing')">
              <img v-if="landingPreviewUrlSrv" :src="landingPreviewUrlSrv" class="imagen-preview imagen-preview--avatar" alt="Avatar" />
              <div v-else class="imagen-placeholder">
                <i class="fa fa-user-circle fa-2x mb-2"></i>
                <span>Foto o logo del tipster</span>
                <span class="imagen-hint">JPG, PNG, WEBP · máx. 5MB · cuadrada recomendado</span>
              </div>
            </div>
            <input ref="inputSrvLanding" type="file" accept="image/jpeg,image/png,image/webp" class="d-none" @change="e => onSeleccionarSrv(e, 'landing')" />
            <div class="img-btn-row mt-2">
              <button v-if="localFilesSrv.landing" class="btn-pers-secondary" @click="subirImagenSrv('landing')" :disabled="subiendoSrv.landing">
                <span v-if="subiendoSrv.landing"><i class="fa fa-spinner fa-spin"></i> Subiendo...</span>
                <span v-else><i class="fa fa-upload"></i> Subir</span>
              </button>
              <button v-if="formSrv.imagen_landing" class="btn-pers-danger" @click="quitarImgSrv('landing')">
                <i class="fa fa-trash"></i> Quitar
              </button>
            </div>
          </div>

          <!-- SECCIÓN: Colores -->
          <div class="pers-section-title">Paleta de colores</div>
          <div class="pers-field">
            <div class="colores-row">
              <div class="color-picker-group">
                <label class="pers-label-sm">Color de fondo</label>
                <p class="pers-color-desc">Base oscura de la landing (fondos, cards)</p>
                <div class="color-pick-wrap">
                  <input type="color" v-model="formSrv.color_primario" class="color-input" />
                  <input v-model="formSrv.color_primario" type="text" class="pers-input color-hex" placeholder="#1a2b3c" maxlength="7" @input="normalizarHexSrv('color_primario')" />
                </div>
              </div>
              <div class="color-picker-group">
                <label class="pers-label-sm">Color de acento</label>
                <p class="pers-color-desc">Botones, textos destacados y CTA</p>
                <div class="color-pick-wrap">
                  <input type="color" v-model="formSrv.color_secundario" class="color-input" />
                  <input v-model="formSrv.color_secundario" type="text" class="pers-input color-hex" placeholder="#f5a623" maxlength="7" @input="normalizarHexSrv('color_secundario')" />
                </div>
              </div>
              <div class="color-picker-group">
                <label class="pers-label-sm">Color del texto</label>
                <p class="pers-color-desc">Color base de los textos de la landing</p>
                <div class="color-pick-wrap">
                  <input type="color" v-model="formSrv.color_texto" class="color-input" />
                  <input v-model="formSrv.color_texto" type="text" class="pers-input color-hex" placeholder="#ffffff" maxlength="7" @input="normalizarHexSrv('color_texto')" />
                </div>
              </div>
            </div>
          </div>

          <!-- SECCIÓN: Textos -->
          <div class="pers-section-title">Textos</div>

          <!-- Subtítulo -->
          <div class="pers-field emoji-field" v-click-outside="() => cerrarEmojiSrv('subtitulo')">
            <div class="label-emoji-row">
              <label class="pers-label">Subtítulo <span class="pers-hint">(máx. 255 caracteres)</span></label>
              <button type="button" class="btn-emoji-toggle" @click.stop="toggleEmojiSrv('subtitulo')" title="Insertar emoji">😊</button>
            </div>
            <div v-if="emojiPanelAbiertSrv === 'subtitulo'" class="emoji-panel">
              <div v-for="(lista, cat) in EMOJIS" :key="cat" class="emoji-cat">
                <div class="emoji-cat-label">{{ cat }}</div>
                <div class="emoji-grid">
                  <span v-for="e in lista" :key="e" class="emoji-item" @click="insertarEmojiSrv('subtitulo', e)">{{ e }}</span>
                </div>
              </div>
            </div>
            <input ref="inputSrvSubtitulo" v-model="formSrv.subtitulo" type="text" class="pers-input" placeholder="Frase descriptiva del servicio" maxlength="255" @blur="guardarCursorSrv('subtitulo')" />
            <span class="char-count">{{ (formSrv.subtitulo || '').length }}/255</span>
          </div>

          <!-- Mensaje promocional -->
          <div class="pers-field emoji-field" v-click-outside="() => cerrarEmojiSrv('mensaje_promocional')">
            <div class="label-emoji-row">
              <label class="pers-label">Mensaje promocional <span class="pers-hint">(entre subtítulo y el botón)</span></label>
              <button type="button" class="btn-emoji-toggle" @click.stop="toggleEmojiSrv('mensaje_promocional')" title="Insertar emoji">😊</button>
            </div>
            <div v-if="emojiPanelAbiertSrv === 'mensaje_promocional'" class="emoji-panel">
              <div v-for="(lista, cat) in EMOJIS" :key="cat" class="emoji-cat">
                <div class="emoji-cat-label">{{ cat }}</div>
                <div class="emoji-grid">
                  <span v-for="e in lista" :key="e" class="emoji-item" @click="insertarEmojiSrv('mensaje_promocional', e)">{{ e }}</span>
                </div>
              </div>
            </div>
            <textarea ref="inputSrvMensaje_promocional" v-model="formSrv.mensaje_promocional" class="pers-textarea" rows="3" placeholder="✅ +95% aciertos en la temporada&#10;🏆 El servicio más seguido de España" maxlength="500" @blur="guardarCursorSrv('mensaje_promocional')"></textarea>
            <span class="char-count">{{ (formSrv.mensaje_promocional || '').length }}/500</span>
          </div>

          <!-- Acciones -->
          <div class="pers-actions">
            <button class="btn-pers-primary" @click="guardarSrv" :disabled="guardandoSrv || hayArchivosLocalesSrv || !formSrv.nombre">
              <span v-if="guardandoSrv"><i class="fa fa-spinner fa-spin"></i> Guardando...</span>
              <span v-else-if="hayArchivosLocalesSrv"><i class="fa fa-exclamation-triangle"></i> Sube las imágenes primero</span>
              <span v-else-if="!formSrv.nombre"><i class="fa fa-exclamation-triangle"></i> Introduce un nombre</span>
              <span v-else><i class="fa fa-save"></i> Guardar cambios</span>
            </button>
          </div>

          <div v-if="mensajeOkSrv" class="pers-toast pers-toast--ok"><i class="fa fa-check-circle"></i> {{ mensajeOkSrv }}</div>
          <div v-if="mensajeErrorSrv" class="pers-toast pers-toast--err"><i class="fa fa-exclamation-circle"></i> {{ mensajeErrorSrv }}</div>
        </div>
      </div>

      <!-- Panel derecho: preview -->
      <div class="col-12 col-lg-6 mt-4 mt-lg-0">
        <div class="card pers-card">
          <div class="pers-card-header">
            <h5 class="pers-title">Vista previa</h5>
            <p class="pers-subtitle">Así verán la landing tus clientes</p>
          </div>
          <div class="preview-phone-wrap">
            <div class="preview-phone">
              <div class="preview-landing" :style="landingStyleSrv">
                <div v-if="bannerPreviewUrlSrv" class="prev-banner-wrap">
                  <img :src="bannerPreviewUrlSrv" class="prev-banner" alt="Banner" />
                </div>
                <div v-else class="prev-banner-placeholder" :style="{ background: formSrv.color_primario || '#0e141f' }"></div>

                <div class="prev-img-wrap">
                  <img v-if="landingPreviewUrlSrv" :src="landingPreviewUrlSrv" class="prev-img" alt="Tipster" />
                  <div v-else class="prev-img prev-img--placeholder"><i class="fa fa-user fa-2x"></i></div>
                </div>

                <div class="prev-tipster-nombre">{{ formSrv.nombre_mostrar || editandoSrvTipsterNombre }}</div>

                <div v-if="formSrv.subtitulo" class="prev-subtitulo">{{ formSrv.subtitulo }}</div>
                <div v-if="formSrv.mensaje_promocional" class="prev-mensaje">{{ formSrv.mensaje_promocional }}</div>

                <button class="prev-btn-unete" :style="btnComprarStyleSrv">{{ textosSrv.boton }}</button>
              </div>
            </div>
          </div>

          <div class="palette-preview" v-if="formSrv.color_primario || formSrv.color_secundario">
            <span class="palette-label">Paleta:</span>
            <div class="palette-chip" :style="{ background: formSrv.color_primario }" :title="formSrv.color_primario"></div>
            <div class="palette-chip" :style="{ background: formSrv.color_secundario }" :title="formSrv.color_secundario"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  </template>
  <!-- ══ FIN TAB SERVICIOS ══ -->

</template>

<script>
import api from "@/services/apiClient.js";

const CAMPOS_IMAGEN = { landing: 'imagen_landing', fondo: 'imagen_fondo', banner: 'imagen_banner' };

const EMOJIS = {
  'Deportes': ['⚽','🏀','🏈','⚾','🎾','🏐','🎱','🏆','🥇','🏅','🎯','🤾','🏋️','🥊','🤺'],
  'Éxito':    ['✅','💯','🔥','⭐','🌟','✨','💎','📈','💰','🤑','💪','🎉','🎊','🚀','👑'],
  'Info':     ['📢','📣','🔔','⚠️','❗','❓','➡️','👉','👆','📌','🗓️','📊','🏷️','🔑','🛡️'],
  'Caras':    ['😊','😎','🤩','🙌','👏','🥳','😍','🤔','🫡','💪','🫶','🤝','👀','🫰','✌️'],
};

const IDIOMAS = [
  { code: 'es', label: '🇪🇸 Español' },
  { code: 'en', label: '🇬🇧 English' },
  { code: 'pt', label: '🇵🇹 Português' },
  { code: 'fr', label: '🇫🇷 Français' },
  { code: 'de', label: '🇩🇪 Deutsch' },
  { code: 'it', label: '🇮🇹 Italiano' },
];

const TEXTOS_IDIOMA = {
  es: { libre: 'ÚNETE GRATIS',          boton: 'Unirse al canal gratis',            suscriptores: 'suscriptores', locale: 'es-ES' },
  en: { libre: 'JOIN FOR FREE',          boton: 'Join the channel for free',          suscriptores: 'subscribers',  locale: 'en-US' },
  pt: { libre: 'JUNTE-SE GRÁTIS',        boton: 'Entrar no canal grátis',             suscriptores: 'subscritores', locale: 'pt-PT' },
  fr: { libre: 'REJOINS GRATUITEMENT',   boton: 'Rejoindre le canal gratuitement',    suscriptores: 'abonnés',      locale: 'fr-FR' },
  de: { libre: 'KOSTENLOS BEITRETEN',    boton: 'Dem Kanal kostenlos beitreten',      suscriptores: 'Abonnenten',   locale: 'de-DE' },
  it: { libre: 'UNISCITI GRATIS',        boton: 'Unisciti al canale gratis',          suscriptores: 'iscritti',     locale: 'it-IT' },
};

const TEXTOS_IDIOMA_SRV = {
  es: { boton: 'Comprar ahora' },
  en: { boton: 'Buy now' },
  pt: { boton: 'Comprar agora' },
  fr: { boton: 'Acheter maintenant' },
  de: { boton: 'Jetzt kaufen' },
  it: { boton: 'Acquista ora' },
};

const FORM_VACIO = {
  nombre:              '',
  nombre_mostrar:      '',
  idioma:              'es',
  imagen_landing:      null,
  imagen_fondo:        null,
  imagen_banner:       null,
  suscriptores:        null,
  color_primario:      '#0e141f',
  color_secundario:    '#f5a623',
  color_texto:         '#ffffff',
  subtitulo:           '',
  mensaje_promocional: '',
  meta_pixel_id:       '',
  meta_page_id_es:     '',
  meta_page_id_en:     '',
};

export default {
  name: 'PersonalizacionTipster',
  directives: {
    clickOutside: {
      mounted(el, binding) {
        el._clickOutsideHandler = (e) => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener('click', el._clickOutsideHandler);
      },
      unmounted(el) {
        document.removeEventListener('click', el._clickOutsideHandler);
      },
    },
  },
  data() {
    return {
      EMOJIS,
      IDIOMAS,
      tipsters: [],
      cargando: false,

      // vista: 'lista' | 'formulario'
      vista: 'lista',
      editandoId: null,
      editandoTipsterId: null,
      editandoTipsterNombre: '',
      guardando: false,
      borrando: null,

      subiendo: { landing: false, fondo: false, banner: false },
      localFiles: { landing: null, fondo: null, banner: null },
      localPreviews: { landing: null, fondo: null, banner: null },
      emojiPanelAbierto: null,
      cursores: { subtitulo: 0, mensaje_promocional: 0 },
      mensajeOk: '',
      mensajeError: '',
      form: { ...FORM_VACIO },

      // ── Tab activo ──
      tabActiva: 'canales',

      // ── Tab Servicios ──
      tipstersSrv: [],
      cargandoSrv: false,
      vistaSrv: 'lista',
      editandoSrvId: null,
      editandoSrvTipsterId: null,
      editandoSrvTipsterNombre: '',
      guardandoSrv: false,
      borrandoSrv: null,
      subiendoSrv: { landing: false, fondo: false, banner: false },
      localFilesSrv: { landing: null, fondo: null, banner: null },
      localPreviewsSrv: { landing: null, fondo: null, banner: null },
      emojiPanelAbiertSrv: null,
      cursoresSrv: { subtitulo: 0, mensaje_promocional: 0 },
      mensajeOkSrv: '',
      mensajeErrorSrv: '',
      formSrv: {
        nombre: '', nombre_mostrar: '', idioma: 'es',
        imagen_landing: null, imagen_fondo: null, imagen_banner: null,
        color_primario: '#0e141f', color_secundario: '#f5a623', color_texto: '#ffffff',
        subtitulo: '', mensaje_promocional: '',
      },
    };
  },
  computed: {
    hayArchivosLocales() {
      return !!(this.localFiles.landing || this.localFiles.fondo || this.localFiles.banner);
    },
    landingPreviewUrl() { return this.buildPreviewUrl('landing'); },
    fondoPreviewUrl()   { return this.buildPreviewUrl('fondo'); },
    bannerPreviewUrl()  { return this.buildPreviewUrl('banner'); },
    landingStyle() {
      const style = { background: this.form.color_primario || '#0e141f' };
      if (this.fondoPreviewUrl) {
        style.backgroundImage   = `url('${this.fondoPreviewUrl}')`;
        style.backgroundSize    = 'cover';
        style.backgroundPosition = 'center';
      }
      return style;
    },
    btnUneteStyle() {
      return { background: this.form.color_secundario || '#f5a623', color: '#000' };
    },
    textosLanding() {
      return TEXTOS_IDIOMA[this.form.idioma] || TEXTOS_IDIOMA['es'];
    },
    hayArchivosLocalesSrv() {
      return !!(this.localFilesSrv.landing || this.localFilesSrv.fondo || this.localFilesSrv.banner);
    },
    landingPreviewUrlSrv() { return this.buildPreviewUrlSrv('landing'); },
    fondoPreviewUrlSrv()   { return this.buildPreviewUrlSrv('fondo'); },
    bannerPreviewUrlSrv()  { return this.buildPreviewUrlSrv('banner'); },
    landingStyleSrv() {
      const style = { background: this.formSrv.color_primario || '#0e141f' };
      const fondoUrl = this.fondoPreviewUrlSrv;
      if (fondoUrl) {
        style.backgroundImage    = `url('${fondoUrl}')`;
        style.backgroundSize     = 'cover';
        style.backgroundPosition = 'center';
      }
      return style;
    },
    btnComprarStyleSrv() {
      return { background: this.formSrv.color_secundario || '#f5a623', color: '#000' };
    },
    textosSrv() {
      return TEXTOS_IDIOMA_SRV[this.formSrv.idioma] || TEXTOS_IDIOMA_SRV['es'];
    },
  },
  async mounted() {
    await this.cargarTipsters();
  },
  methods: {
    irInicio() { this.$router.push('/'); },

    async cargarTipsters() {
      this.cargando = true;
      try {
        const res = await this.$store.dispatch('auth/tipsterLandingObtener', {});
        this.tipsters = res.tipsters || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.cargando = false;
      }
    },

    // ── Navegación entre vistas ─────────────────────────────────
    abrirFormulario(tipsterId, tipsterNombre, pers) {
      this.limpiarMensajes();
      this.localFiles    = { landing: null, fondo: null, banner: null };
      this.localPreviews = { landing: null, fondo: null, banner: null };
      this.editandoTipsterId    = tipsterId;
      this.editandoTipsterNombre = tipsterNombre;
      this.editandoId = pers?.id ?? null;
      this.form = {
        nombre:              pers?.nombre              || '',
        nombre_mostrar:      pers?.nombre_mostrar      || '',
        idioma:              pers?.idioma              || 'es',
        imagen_landing:      pers?.imagen_landing      || null,
        imagen_fondo:        pers?.imagen_fondo        || null,
        imagen_banner:       pers?.imagen_banner       || null,
        suscriptores:        pers?.suscriptores        ?? null,
        color_primario:      pers?.color_primario      || '#0e141f',
        color_secundario:    pers?.color_secundario    || '#f5a623',
        color_texto:         pers?.color_texto         || '#ffffff',
        subtitulo:           pers?.subtitulo           || '',
        mensaje_promocional: pers?.mensaje_promocional || '',
        meta_pixel_id:       pers?.meta_pixel_id       || '',
        meta_page_id_es:     pers?.meta_page_id_es     || '',
        meta_page_id_en:     pers?.meta_page_id_en     || '',
      };
      this.vista = 'formulario';
    },

    volver() {
      this.vista = 'lista';
      this.limpiarMensajes();
    },

    // ── Borrar ──────────────────────────────────────────────────
    async confirmarBorrar(tipsterId, id, nombre) {
      if (!confirm(`¿Eliminar la personalización «${nombre}»? Esta acción no se puede deshacer.`)) return;
      this.borrando = id;
      this.limpiarMensajes();
      try {
        await this.$store.dispatch('auth/tipsterLandingBorrar', id);
        const t = this.tipsters.find(t => t.tipster_id === tipsterId);
        if (t) t.personalizaciones = t.personalizaciones.filter(p => p.id !== id);
      } catch (e) {
        const msg = e?.response?.data?.message || 'Error al eliminar.';
        this.mostrarError(msg);
      } finally {
        this.borrando = null;
      }
    },

    // ── Guardar / Crear ─────────────────────────────────────────
    async guardar() {
      if (!this.form.nombre) return;
      this.guardando = true;
      this.limpiarMensajes();

      const payload = {
        nombre:              this.form.nombre              || null,
        nombre_mostrar:      this.form.nombre_mostrar      || null,
        idioma:              this.form.idioma              || 'es',
        imagen_landing:      this.form.imagen_landing      || null,
        imagen_fondo:        this.form.imagen_fondo        || null,
        imagen_banner:       this.form.imagen_banner       || null,
        suscriptores:        this.form.suscriptores        || null,
        color_primario:      this.form.color_primario      || null,
        color_secundario:    this.form.color_secundario    || null,
        color_texto:         this.form.color_texto         || null,
        subtitulo:           this.form.subtitulo           || null,
        mensaje_promocional: this.form.mensaje_promocional || null,
        meta_pixel_id:       this.form.meta_pixel_id       || null,
        meta_page_id_es:     this.form.meta_page_id_es     || null,
        meta_page_id_en:     this.form.meta_page_id_en     || null,
      };

      try {
        if (this.editandoId) {
          // Actualizar existente
          const res = await this.$store.dispatch('auth/tipsterLandingGuardar', {
            id: this.editandoId,
            ...payload,
          });
          this.actualizarLocal(res.data);
        } else {
          // Crear nueva
          const res = await this.$store.dispatch('auth/tipsterLandingCrear', {
            tipster_id: this.editandoTipsterId,
            ...payload,
          });
          this.editandoId = res.data.id;
          this.agregarLocal(res.data);
        }
        this.mostrarOk('Personalización guardada correctamente.');
      } catch (e) {
        const msg = e?.response?.data?.message || 'Error al guardar. Inténtalo de nuevo.';
        this.mostrarError(msg);
      } finally {
        this.guardando = false;
      }
    },

    // ── Actualiza estado local tras guardar / crear ──────────────
    actualizarLocal(data) {
      const t = this.tipsters.find(t => t.tipster_id === this.editandoTipsterId);
      if (!t) return;
      const idx = t.personalizaciones.findIndex(p => p.id === data.id);
      if (idx !== -1) t.personalizaciones.splice(idx, 1, data);
    },

    agregarLocal(data) {
      const t = this.tipsters.find(t => t.tipster_id === this.editandoTipsterId);
      if (t) t.personalizaciones.push(data);
    },

    // ── Imágenes ────────────────────────────────────────────────
    buildPreviewUrl(tipo) {
      const local = this.localPreviews[tipo];
      if (local) return local;
      const campo = CAMPOS_IMAGEN[tipo];
      const url = this.form[campo];
      if (!url) return null;
      if (url.startsWith('http')) return url;
      return process.env.VUE_APP_API_BASE_URL + url;
    },

    onSeleccionarGenerico(e, tipo) {
      const file = e.target.files[0];
      if (!file) return;
      this.localFiles[tipo]    = file;
      this.localPreviews[tipo] = URL.createObjectURL(file);
    },

    onDropGenerico(e, tipo) {
      const file = e.dataTransfer.files[0];
      if (!file) return;
      this.localFiles[tipo]    = file;
      this.localPreviews[tipo] = URL.createObjectURL(file);
    },

    async subirImagenGenerico(tipo) {
      if (!this.localFiles[tipo] || !this.editandoTipsterId) return;
      this.subiendo[tipo] = true;
      try {
        const res = await this.$store.dispatch('auth/tipsterLandingUploadImagen', {
          tipsterId: this.editandoTipsterId,
          file: this.localFiles[tipo],
        });
        const campo = CAMPOS_IMAGEN[tipo];
        this.form[campo]         = res.url;
        this.localFiles[tipo]    = null;
        this.localPreviews[tipo] = null;
        this.mostrarOk('Imagen subida. Haz clic en Guardar para confirmar.');
      } catch (e) {
        this.mostrarError('Error al subir la imagen.');
      } finally {
        this.subiendo[tipo] = false;
      }
    },

    quitarImagenGenerico(tipo) {
      const campo = CAMPOS_IMAGEN[tipo];
      this.form[campo]         = null;
      this.localFiles[tipo]    = null;
      this.localPreviews[tipo] = null;
    },

    // ── Colores ─────────────────────────────────────────────────
    normalizarHex(campo) {
      let val = this.form[campo] || '';
      if (val && !val.startsWith('#')) val = '#' + val;
      this.form[campo] = val.slice(0, 7);
    },

    // ── Emoji ───────────────────────────────────────────────────
    toggleEmoji(campo) {
      this.emojiPanelAbierto = this.emojiPanelAbierto === campo ? null : campo;
    },
    cerrarEmoji(campo) {
      if (this.emojiPanelAbierto === campo) this.emojiPanelAbierto = null;
    },
    guardarCursor(campo) {
      const refKey = campo === 'subtitulo' ? 'inputSubtitulo' : 'inputMensaje_promocional';
      const el = this.$refs[refKey];
      if (el) this.cursores[campo] = el.selectionStart ?? (this.form[campo] || '').length;
    },
    insertarEmoji(campo, emoji) {
      const refKey = campo === 'subtitulo' ? 'inputSubtitulo' : 'inputMensaje_promocional';
      const el = this.$refs[refKey];
      const pos = el ? (el.selectionStart ?? this.cursores[campo]) : this.cursores[campo];
      const actual = this.form[campo] || '';
      this.form[campo] = actual.slice(0, pos) + emoji + actual.slice(pos);
      const nuevaPos = pos + [...emoji].length;
      this.cursores[campo] = nuevaPos;
      this.$nextTick(() => {
        if (el) { el.selectionStart = el.selectionEnd = nuevaPos; el.focus(); }
      });
    },

    // ── Helpers ─────────────────────────────────────────────────
    formatNum(n) {
      if (!n) return '0';
      const locale = this.textosLanding?.locale || 'es-ES';
      return Number(n).toLocaleString(locale);
    },
    mostrarOk(msg) {
      this.mensajeOk = msg;
      setTimeout(() => { this.mensajeOk = ''; }, 3500);
    },
    mostrarError(msg) {
      this.mensajeError = msg;
      setTimeout(() => { this.mensajeError = ''; }, 4500);
    },
    limpiarMensajes() {
      this.mensajeOk = '';
      this.mensajeError = '';
    },

    // ── Tab Servicios ──────────────────────────────────────────
    cambiarTab(tab) {
      this.tabActiva = tab;
      if (tab === 'servicios' && this.tipstersSrv.length === 0) {
        this.cargarTipstersSrv();
      }
    },

    async cargarTipstersSrv() {
      this.cargandoSrv = true;
      try {
        const { data } = await api.post('/api/v2/tipster-landing-servicio/listar');
        this.tipstersSrv = data.tipsters || [];
      } catch (e) {
        this.mensajeErrorSrv = 'Error al cargar.';
      } finally {
        this.cargandoSrv = false;
      }
    },

    abrirFormularioSrv(tipsterId, tipsterNombre, pers) {
      this.editandoSrvId           = pers ? pers.id : null;
      this.editandoSrvTipsterId    = tipsterId;
      this.editandoSrvTipsterNombre = tipsterNombre;
      this.mensajeOkSrv            = '';
      this.mensajeErrorSrv         = '';
      this.subiendoSrv             = { landing: false, fondo: false, banner: false };
      this.localFilesSrv           = { landing: null, fondo: null, banner: null };
      this.localPreviewsSrv        = { landing: null, fondo: null, banner: null };
      this.emojiPanelAbiertSrv     = null;
      this.cursoresSrv             = { subtitulo: 0, mensaje_promocional: 0 };
      this.formSrv = pers ? {
        nombre:              pers.nombre,
        nombre_mostrar:      pers.nombre_mostrar || '',
        idioma:              pers.idioma || 'es',
        imagen_landing:      pers.imagen_landing || null,
        imagen_fondo:        pers.imagen_fondo   || null,
        imagen_banner:       pers.imagen_banner  || null,
        color_primario:      pers.color_primario    || '#0e141f',
        color_secundario:    pers.color_secundario  || '#f5a623',
        color_texto:         pers.color_texto       || '#ffffff',
        subtitulo:           pers.subtitulo           || '',
        mensaje_promocional: pers.mensaje_promocional || '',
      } : {
        nombre: '', nombre_mostrar: '', idioma: 'es',
        imagen_landing: null, imagen_fondo: null, imagen_banner: null,
        color_primario: '#0e141f', color_secundario: '#f5a623', color_texto: '#ffffff',
        subtitulo: '', mensaje_promocional: '',
      };
      this.vistaSrv = 'formulario';
    },

    volverSrv() {
      this.vistaSrv = 'lista';
      this.editandoSrvId = null;
      this.mensajeOkSrv = '';
      this.mensajeErrorSrv = '';
    },

    async guardarSrv() {
      this.guardandoSrv = true;
      this.mensajeOkSrv = '';
      this.mensajeErrorSrv = '';
      const payload = {
        tipster_id:           this.editandoSrvTipsterId,
        nombre:               this.formSrv.nombre,
        nombre_mostrar:       this.formSrv.nombre_mostrar || null,
        idioma:               this.formSrv.idioma,
        imagen_landing:       this.formSrv.imagen_landing || null,
        imagen_fondo:         this.formSrv.imagen_fondo   || null,
        imagen_banner:        this.formSrv.imagen_banner  || null,
        color_primario:       this.formSrv.color_primario,
        color_secundario:     this.formSrv.color_secundario,
        color_texto:          this.formSrv.color_texto || null,
        subtitulo:            this.formSrv.subtitulo || null,
        mensaje_promocional:  this.formSrv.mensaje_promocional || null,
      };
      if (this.editandoSrvId) payload.id = this.editandoSrvId;
      const url = this.editandoSrvId
        ? '/api/v2/tipster-landing-servicio/guardar'
        : '/api/v2/tipster-landing-servicio/crear';
      try {
        await api.post(url, payload);
        this.mensajeOkSrv = 'Guardado correctamente.';
        await this.cargarTipstersSrv();
        setTimeout(() => this.volverSrv(), 1200);
      } catch (e) {
        this.mensajeErrorSrv = e?.response?.data?.message || 'Error al guardar.';
      } finally {
        this.guardandoSrv = false;
      }
    },

    async confirmarBorrarSrv(tipsterId, id, nombre) {
      if (!confirm(`¿Eliminar la personalización "${nombre}"?`)) return;
      this.borrandoSrv = id;
      try {
        await api.post('/api/v2/tipster-landing-servicio/borrar', { id });
        await this.cargarTipstersSrv();
      } catch (e) {
        this.mensajeErrorSrv = 'Error al eliminar.';
      } finally {
        this.borrandoSrv = null;
      }
    },

    buildPreviewUrlSrv(tipo) {
      const local = this.localPreviewsSrv[tipo];
      if (local) return local;
      const campo = { landing: 'imagen_landing', fondo: 'imagen_fondo', banner: 'imagen_banner' }[tipo];
      const url = this.formSrv[campo];
      if (!url) return null;
      if (url.startsWith('http')) return url;
      return process.env.VUE_APP_API_BASE_URL + url;
    },

    onSeleccionarSrv(e, tipo) {
      const file = e.target.files[0];
      if (!file) return;
      this.localFilesSrv[tipo]    = file;
      this.localPreviewsSrv[tipo] = URL.createObjectURL(file);
    },

    onDropSrv(e, tipo) {
      const file = e.dataTransfer.files[0];
      if (!file) return;
      this.localFilesSrv[tipo]    = file;
      this.localPreviewsSrv[tipo] = URL.createObjectURL(file);
    },

    async subirImagenSrv(tipo) {
      if (!this.localFilesSrv[tipo] || !this.editandoSrvTipsterId) return;
      this.subiendoSrv[tipo] = true;
      const formData = new FormData();
      formData.append('tipster_id', this.editandoSrvTipsterId);
      formData.append('imagen', this.localFilesSrv[tipo]);
      try {
        const { data } = await api.post('/api/v2/tipster-landing-servicio/upload-imagen', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        const key = { landing: 'imagen_landing', fondo: 'imagen_fondo', banner: 'imagen_banner' }[tipo];
        this.formSrv[key]           = data.url;
        this.localFilesSrv[tipo]    = null;
        this.localPreviewsSrv[tipo] = null;
        this.mensajeOkSrv = 'Imagen subida. Haz clic en Guardar para confirmar.';
        setTimeout(() => { this.mensajeOkSrv = ''; }, 3500);
      } catch (e) {
        this.mensajeErrorSrv = 'Error al subir la imagen.';
      } finally {
        this.subiendoSrv[tipo] = false;
      }
    },

    quitarImgSrv(tipo) {
      const key = { landing: 'imagen_landing', fondo: 'imagen_fondo', banner: 'imagen_banner' }[tipo];
      this.formSrv[key]           = null;
      this.localFilesSrv[tipo]    = null;
      this.localPreviewsSrv[tipo] = null;
    },

    toggleEmojiSrv(campo) {
      this.emojiPanelAbiertSrv = this.emojiPanelAbiertSrv === campo ? null : campo;
    },
    cerrarEmojiSrv(campo) {
      if (this.emojiPanelAbiertSrv === campo) this.emojiPanelAbiertSrv = null;
    },
    guardarCursorSrv(campo) {
      const refKey = campo === 'subtitulo' ? 'inputSrvSubtitulo' : 'inputSrvMensaje_promocional';
      const el = this.$refs[refKey];
      if (el) this.cursoresSrv[campo] = el.selectionStart ?? (this.formSrv[campo] || '').length;
    },
    insertarEmojiSrv(campo, emoji) {
      const refKey = campo === 'subtitulo' ? 'inputSrvSubtitulo' : 'inputSrvMensaje_promocional';
      const el = this.$refs[refKey];
      const pos = el ? (el.selectionStart ?? this.cursoresSrv[campo]) : this.cursoresSrv[campo];
      const actual = this.formSrv[campo] || '';
      this.formSrv[campo] = actual.slice(0, pos) + emoji + actual.slice(pos);
      const nuevaPos = pos + [...emoji].length;
      this.cursoresSrv[campo] = nuevaPos;
      this.$nextTick(() => {
        if (el) { el.selectionStart = el.selectionEnd = nuevaPos; el.focus(); }
      });
    },
    normalizarHexSrv(campo) {
      let val = this.formSrv[campo] || '';
      if (val && !val.startsWith('#')) val = '#' + val;
      this.formSrv[campo] = val.slice(0, 7);
    },
  },
};
</script>

<style scoped>
/* ── Tarjeta base ─────────────────────────────────────────── */
.pers-card {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: var(--q-radius);
  padding: 24px;
  min-height: 200px;
}
.pers-card-header { margin-bottom: 20px; }
.pers-title { color: var(--q-text); font-family: var(--q-font-display); font-size: 18px; font-weight: 700; margin: 0 0 4px; }
.pers-subtitle { color: var(--q-muted); font-size: 13px; margin: 0; }

/* ── Cabecera del formulario con botón volver ──────────────── */
.form-header-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.btn-volver {
  flex-shrink: 0;
  background: var(--q-hover);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-muted);
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  cursor: pointer;
  transition: background .15s, color .15s;
  margin-top: 2px;
  white-space: nowrap;
}
.btn-volver:hover { background: var(--q-border); color: var(--q-text); }

/* ── Lista de tipsters ─────────────────────────────────────── */
.tipster-group {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: var(--q-radius);
  overflow: hidden;
}

.tipster-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: var(--q-card-alt);
  border-bottom: 1px solid var(--q-border);
}

.tipster-group-nombre {
  font-family: var(--q-font-display);
  font-size: 15px;
  font-weight: 700;
  color: var(--q-text);
}

.btn-nuevo-pers {
  background: var(--q-gold);
  color: var(--q-gold-on);
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background .15s;
  flex-shrink: 0;
}
.btn-nuevo-pers:hover { background: var(--q-gold-hover); }

.pers-list-empty {
  padding: 20px 18px;
  color: var(--q-muted);
  font-size: 13px;
  font-style: italic;
}

.pers-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.pers-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-top: 1px solid var(--q-border);
  gap: 12px;
  transition: background .1s;
}
.pers-list-item:hover { background: var(--q-hover); }

.pers-list-item-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.pers-list-nombre {
  font-size: 14px;
  font-weight: 600;
  color: var(--q-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pers-list-chips {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.pers-chip {
  font-size: 10px;
  background: var(--q-hover);
  color: var(--q-muted);
  border: 1px solid var(--q-border-md);
  border-radius: 10px;
  padding: 2px 7px;
}

.pers-color-dot {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid var(--q-border-md);
  flex-shrink: 0;
}

.pers-list-item-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.btn-sm {
  padding: 5px 10px !important;
  font-size: 12px !important;
}

/* ── Nombre + idioma en fila ────────────────────────────────── */
.nombre-idioma-row {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
  align-items: flex-start;
}
.nombre-idioma-row .flex-1 { flex: 1; min-width: 0; }
.idioma-select-wrap { width: 160px; flex-shrink: 0; }

/* ── Secciones del formulario ──────────────────────────────── */
.pers-section-title {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .8px;
  color: var(--q-gold);
  margin: 24px 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--q-border);
}

/* ── Campos ────────────────────────────────────────────────── */
.pers-field { margin-bottom: 18px; }
.pers-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: var(--q-muted);
  margin-bottom: 6px;
}
.pers-label-sm {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: var(--q-muted);
  margin-bottom: 4px;
}
.pers-hint { font-weight: 400; text-transform: none; letter-spacing: 0; font-size: 11px; }
.pers-color-desc { font-size: 11px; color: var(--q-muted); margin: 2px 0 6px; line-height: 1.3; }

.pers-input, .pers-textarea {
  width: 100%;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 9px 12px;
  font-size: 14px;
  outline: none;
  transition: border-color .15s;
}
.pers-input:focus, .pers-textarea:focus { border-color: var(--q-gold); }
.pers-textarea { resize: vertical; font-family: var(--q-font-ui); }
.char-count { font-size: 11px; color: var(--q-muted); display: block; text-align: right; margin-top: 3px; }
.pers-field-help { display: block; font-size: 11px; color: var(--q-muted); margin-top: 4px; }

/* ── Upload areas ───────────────────────────────────────────── */
.imagen-upload-area {
  border: 2px dashed var(--q-border-md);
  border-radius: 8px;
  cursor: pointer;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color .15s;
  overflow: hidden;
}
.imagen-upload-area:hover { border-color: var(--q-gold); }
.imagen-upload-area--banner { min-height: 80px; }

.imagen-preview { width: 100%; max-height: 180px; object-fit: cover; border-radius: 6px; }
.imagen-preview--fondo { max-height: 120px; }
.imagen-preview--avatar { max-height: 120px; object-fit: contain; }

.imagen-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  color: var(--q-muted);
  font-size: 13px;
  padding: 20px;
  text-align: center;
}
.imagen-hint { font-size: 11px; color: var(--q-muted); margin-top: 2px; }
.img-btn-row { display: flex; gap: 8px; flex-wrap: wrap; }

/* ── Colores ────────────────────────────────────────────────── */
.colores-row { display: flex; gap: 16px; flex-wrap: wrap; }
.color-picker-group { flex: 1; min-width: 140px; }
.color-pick-wrap { display: flex; align-items: center; gap: 8px; }
.color-input {
  width: 40px;
  height: 36px;
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  padding: 2px;
  cursor: pointer;
  background: var(--q-card-alt);
  flex-shrink: 0;
}
.color-hex { flex: 1; font-family: var(--q-font-mono); font-size: 13px; }

/* ── Botones ────────────────────────────────────────────────── */
.pers-actions { margin-top: 24px; }
.btn-pers-primary {
  background: var(--q-gold);
  color: var(--q-gold-on);
  border: none;
  border-radius: 6px;
  padding: 10px 24px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background .15s;
}
.btn-pers-primary:hover:not(:disabled) { background: var(--q-gold-hover); }
.btn-pers-primary:disabled { opacity: .5; cursor: not-allowed; }

.btn-pers-secondary {
  background: var(--q-hover);
  color: var(--q-text);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
  transition: background .15s;
}
.btn-pers-secondary:hover:not(:disabled) { background: var(--q-border); }
.btn-pers-secondary:disabled { opacity: .5; cursor: not-allowed; }

.btn-pers-danger {
  background: var(--q-red-soft);
  color: var(--q-red);
  border: 1px solid var(--q-red);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}
.btn-pers-danger:hover:not(:disabled) { background: var(--q-red); color: #fff; }
.btn-pers-danger:disabled { opacity: .5; cursor: not-allowed; }

/* ── Toast ──────────────────────────────────────────────────── */
.pers-toast {
  margin-top: 14px;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
}
.pers-toast--ok  { background: var(--q-green-soft); color: var(--q-green); border: 1px solid var(--q-green); }
.pers-toast--err { background: var(--q-red-soft);   color: var(--q-red);   border: 1px solid var(--q-red); }

/* ── Empty state ────────────────────────────────────────────── */
.pers-empty {
  text-align: center;
  padding: 48px 24px;
  color: var(--q-muted);
  font-size: 14px;
}
.pers-empty i { display: block; margin-bottom: 12px; }

/* ── Preview phone ──────────────────────────────────────────── */
.preview-phone-wrap { display: flex; justify-content: center; padding: 8px 0 8px; }
.preview-phone {
  width: 260px;
  border: 8px solid var(--q-border-md);
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,.5);
}
.preview-landing {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: background .2s;
  padding-bottom: 24px;
}

.prev-banner-wrap { width: 100%; flex-shrink: 0; }
.prev-banner { width: 100%; height: 80px; object-fit: cover; display: block; }
.prev-banner-placeholder { width: 100%; height: 40px; flex-shrink: 0; opacity: .4; }

.prev-img-wrap { margin-top: 8px; }
.prev-img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  display: block;
}
.prev-img--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,.08);
  color: rgba(255,255,255,.4);
}
.prev-tipster-nombre {
  font-weight: 800;
  font-size: 15px;
  color: #fff;
  text-align: center;
  font-family: var(--q-font-display);
  padding: 0 12px;
}
.prev-subtitulo {
  font-size: 11px;
  color: rgba(255,255,255,.75);
  text-align: center;
  line-height: 1.4;
  padding: 0 14px;
}
.prev-suscriptores {
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}
.prev-mensaje {
  font-size: 10px;
  color: rgba(255,255,255,.8);
  text-align: center;
  white-space: pre-line;
  line-height: 1.5;
  background: rgba(255,255,255,.07);
  border-radius: 8px;
  padding: 7px 10px;
  margin: 0 12px;
  width: calc(100% - 24px);
}
.prev-free {
  font-size: 10px;
  font-weight: 900;
  letter-spacing: .06em;
  margin-top: 6px;
}
.prev-btn-unete {
  border: none;
  border-radius: 24px;
  padding: 9px 24px;
  font-weight: 800;
  font-size: 12px;
  cursor: default;
  margin-top: 4px;
}

/* ── Paleta visual bajo el preview ─────────────────────────── */
.palette-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  padding: 12px 0 4px;
}
.palette-label { font-size: 11px; color: var(--q-muted); }
.palette-chip {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid var(--q-border-md);
  flex-shrink: 0;
}

/* ── Breadcrumb ─────────────────────────────────────────────── */
.breadcrumb { background: transparent; padding: 0; }
.breadcrumb-item { cursor: pointer; color: var(--q-gold); }
.breadcrumb-item:hover { text-decoration: underline; }

/* ── Emoji picker ───────────────────────────────────────────── */
.emoji-field { position: relative; }
.label-emoji-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.label-emoji-row .pers-label { margin-bottom: 0; }
.btn-emoji-toggle {
  background: var(--q-hover);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 3px 7px;
  transition: background .15s, border-color .15s;
  flex-shrink: 0;
}
.btn-emoji-toggle:hover { background: var(--q-border); border-color: var(--q-gold); }
.emoji-panel {
  position: absolute;
  right: 0;
  top: 28px;
  z-index: 200;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 10px;
  padding: 10px;
  width: 280px;
  max-height: 240px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0,0,0,.5);
}
.emoji-cat { margin-bottom: 8px; }
.emoji-cat-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: var(--q-muted);
  margin-bottom: 4px;
}
.emoji-grid { display: flex; flex-wrap: wrap; gap: 2px; }
.emoji-item {
  font-size: 20px;
  cursor: pointer;
  padding: 3px 4px;
  border-radius: 5px;
  line-height: 1;
  transition: background .1s;
  user-select: none;
}
.emoji-item:hover { background: var(--q-hover); }

/* ── Responsive ─────────────────────────────────────────────── */
@media (max-width: 768px) {
  .pers-card { padding: 16px; }
  .preview-phone { width: 220px; }
  .colores-row { flex-direction: column; }
  .emoji-panel { width: 240px; right: 0; }
  .tipster-group-header { flex-wrap: wrap; gap: 8px; }
  .pers-list-item { flex-wrap: wrap; }
  .pers-list-item-info { min-width: 0; }
}

/* ── Tabs canales / servicios ───────────────────────────── */
.pers-tabs {
  display: flex;
  gap: 0.4rem;
}
.pers-tab {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  color: var(--q-text, #c8d6e5);
  border-radius: 0.5rem;
  padding: 0.38rem 1rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.pers-tab--activo {
  background: var(--q-gold, #f5a623);
  color: #000;
  border-color: var(--q-gold, #f5a623);
}

/* ── Imágenes Servicios ─────────────────────────────────── */
.pers-img-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.pers-file-input {
  font-size: 0.8rem;
  color: var(--q-text, #c8d6e5);
}
.pers-uploading { font-size: 0.78rem; opacity: 0.7; }
.pers-img-ok { font-size: 0.78rem; color: #28a745; }

/* ── Colores Servicios ─────────────────────────────────── */
.pers-color-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.pers-color-input {
  width: 36px;
  height: 32px;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
  padding: 2px;
}
.pers-input--color { flex: 1; }
</style>
